import { observer } from 'mobx-react';
import React from 'react';

// Translations
import translate from '../Translate.js';

const Footer = observer(class Footer extends React.Component {
  // changeLocale(locale) {
  //   if(locale) {
  //     this.props.store.SessionStore.updateLocale(locale);
  //   }
  // }

  render() {
    // Hund system status (check on a 100ms interval if anchor is there)
    // const statusElDelay = setInterval(function(){
    //   if(document.querySelector('#status') && window.Status) {
    //     new window.Status.Widget({
    //       hostname: 'status.smarterproctoring.com',
    //       selector: '#status',
    //       css: false,
    //       display: {
    //         hideOnError: true,
    //         ledOnly: true,
    //         panePosition: 'top-left'
    //       }
    //     });
    //
    //     clearInterval(statusElDelay);
    //   }
    // }, 100)

    return(
      <footer className="site-foot">
        <div className="site-foot__copy wrap">
          <span>
            © {new Date().getFullYear()} SmarterServices, LLC
          </span>

          <nav>
            <ul className="site-foot__nav">
              <li>
                <a 
                  href="https://www.smarterservices.com/privacy-policy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a 
                  href="https://www.smarterservices.com/terms-of-use" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Terms of Use
                </a>
              </li>
              <li>
                <a 
                  href="https://www.smarterservices.com/accessibility" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Accessibility Statement
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </footer>
    );
  }
})

export default translate('Footer')(Footer);



// WEBPACK FOOTER //
// ./src/app/components/Common/Footer.js